import $const from "./const";
import moment from "moment";
import { saveAs } from "file-saver";
import agent from "../agent";

let timer;

export default {
  countWordsLength(str) {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i);
      //单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++;
      } else {
        len += 2;
      }
    }
    return len;
  },
  makeInviteCode() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  },
  checkIsCaptain(info, user) {
    let isCaptain = false;
    if (
      info &&
      user &&
      user.id &&
      info.gteamMembers &&
      info.gteamMembers.nodes &&
      info.gteamMembers.nodes.length > 0
    ) {
      info.gteamMembers.nodes.forEach(member => {
        if (member.memberId === user.id.toString()) {
          if (member.position && member.position.code === "CAPTAIN") {
            isCaptain = true;
          }
        }
      });
    }
    return isCaptain;
  },
  // 检查是否为副队长
  checkIsSubCaptain(info, user) {
    let isSubCaptain = false;
    if (
      info &&
      user &&
      user.id &&
      info.gteamMembers &&
      info.gteamMembers.nodes &&
      info.gteamMembers.nodes.length > 0
    ) {
      info.gteamMembers.nodes.forEach(member => {
        if (member.memberId === user.id.toString()) {
          if (member.teamManagementMark === true) {
            isSubCaptain = true;
          }
        }
      });
    }
    return isSubCaptain;
  },
  getDomainLocale(lang) {
    return lang === "zh" ? "zh-CN" : "en-US";
  },
  formatTeamPosition(teamInfo) {
    let positionLimit = [];
    if (
      teamInfo &&
      teamInfo.gevent &&
      teamInfo.gevent.positionPolicies &&
      teamInfo.gevent.positionPolicies.nodes &&
      teamInfo.gevent.positionPolicies.nodes.length > 0 &&
      teamInfo.gevent.positionPolicies.nodes[0].status === $const.EVENT_POSITION_STATUS.OK
    ) {
      let conditions = teamInfo.gevent.positionPolicies.nodes[0].conditions;
      if (conditions && conditions.nodes && conditions.nodes.length > 0) {
        conditions.nodes.forEach(condition => {
          positionLimit.push({
            id: condition.id,
            num: 0,
            min: condition.min,
            max: condition.max,
            eventPositions:
              condition.conditionEventPositions &&
              condition.conditionEventPositions.nodes &&
              condition.conditionEventPositions.nodes.length > 0
                ? condition.conditionEventPositions.nodes
                : []
          });
        });
      }
    }
    if (
      positionLimit.length > 0 &&
      teamInfo &&
      teamInfo.gteamMembers &&
      teamInfo.gteamMembers.nodes &&
      teamInfo.gteamMembers.nodes.length > 0
    ) {
      teamInfo.gteamMembers.nodes.forEach(item => {
        positionLimit.forEach(positon => {
          let slug = false;
          if (positon && positon.eventPositions && positon.eventPositions.length > 0) {
            positon.eventPositions &&
              positon.eventPositions.forEach(eventPosition => {
                if (
                  eventPosition &&
                  eventPosition.eventPosition &&
                  eventPosition.eventPosition.position.code === item.position.code
                ) {
                  slug = true;
                }
              });
          }
          if (slug) {
            positon.num++;
          }
        });
      });
    }
    return positionLimit;
  },
  getAreaOptions(lang) {
    let BASE_COUNTRY_OPS_EN = JSON.parse(JSON.stringify($const.BASE_COUNTRY_OPS));
    if (lang === "zh") {
      return $const.BASE_COUNTRY_OPS;
    }
    // 英文城市名
    return BASE_COUNTRY_OPS_EN.map(item => {
      if (item.children && item.children.length > 0) {
        item.children = item.children.map(i => {
          i.label = i.enLabel;
          return i;
        });
      }
      item.label = item.enLabel;
      return item;
    });
  },
  checkTeamInfo(teamInfo) {
    let slug = true;
    // 资料校验
    if (
      !teamInfo.collegeId &&
      (!teamInfo.collegeName ||
        !teamInfo.collegeBadge ||
        !teamInfo.district ||
        !teamInfo.collegeAbbreviation)
    ) {
      slug = false;
    }
    return slug;
  },
  checkTeamMembers(teamInfo) {
    let slug = true;
    // 人数限制校验
    teamInfo &&
      teamInfo.positionLimit &&
      teamInfo.positionLimit.length > 0 &&
      teamInfo.positionLimit.forEach(position => {
        if (position.min !== undefined && position.num < position.min) {
          slug = false;
        }
        if (position.max !== undefined && position.num > position.max) {
          slug = false;
        }
      });
    return slug;
  },
  formatStageStatus(nodes, registrations) {
    if (!nodes || !registrations) {
      return;
    }
    nodes.length > 0 &&
      nodes.forEach(node => {
        registrations.length > 0 &&
          registrations.forEach(registration => {
            // 当前节点状态
            if (node.id === registration.stageId) {
              // node.parentStageId === registration.stageId
              node.myStageStatus = registration.stageStatus.status.code;
            }
            if (node.parentStageId === registration.stageId) {
              // 父环节有状态则记录父环节的状态
              node.parentStageStatus = registration.stageStatus.status.code;
            }
          });
      });
    // return nodes
  },
  // 格式化环节的面试数据
  formatMeeting(nodes, registrationId) {
    if (!nodes) return;
    nodes.length > 0 &&
      nodes.forEach(node => {
        let meetings = [];
        let dateOptions = [];
        let aloneDateOptions = [];
        let batchDateOptions = [];
        let myMeeting = undefined;
        let hasSubmittedMeeting = false;
        // 面试预约环节相关
        const stageMeetings = node.meetings.nodes;
        const now = new Date();
        stageMeetings.forEach((meeting, index) => {
          if (meeting && meeting.registrationMeetings && meeting.registrationMeetings.nodes) {
            const totalCount = meeting.registrationMeetings.totalCount;
            const registrationMeetings = meeting.registrationMeetings.nodes;
            registrationMeetings.forEach(rm => {
              if (rm.registrationId === registrationId) {
                hasSubmittedMeeting = true;
                myMeeting = {
                  ...rm,
                  meeting: {
                    ...meeting,
                    date: moment(meeting.beginAt).format("YYYY-MM-DD")
                  }
                };
              }
            });
            let beginAt = moment(meeting.beginAt).format("YYYY-MM-DD");
            let endAt = moment(meeting.endAt).format("YYYY-MM-DD");
            // 只显示一个小时之后的预约
            if (new Date(meeting.beginAt) - now > 3600 * 1000) {
              // 加工 meeting 数据
              meetings.push({
                ...meeting,
                date: beginAt,
                full: totalCount >= meeting.maxNum,
                batchDate: beginAt !== endAt ? beginAt + "~" + endAt : "",
                aloneDate: beginAt === endAt ? beginAt : ""
              });
            }
          }
        });
        dateOptions = new Set(meetings.map(meeting => meeting.date));
        dateOptions = [...dateOptions];
        meetings.forEach(meeting => {
          if (meeting.aloneDate !== "") {
            aloneDateOptions.push({
              aloneDate: meeting.aloneDate,
              full: meeting.full,
              id: meeting.id
            });
          }
          if (meeting.batchDate !== "") {
            batchDateOptions.push({
              batchDate: meeting.batchDate,
              full: meeting.full,
              id: meeting.id
            });
          }
        });
        aloneDateOptions = [...aloneDateOptions];

        batchDateOptions = [...batchDateOptions];
        if (dateOptions.length > 8) dateOptions = dateOptions.splice(0, 8);
        if (dateOptions.length > 8) aloneDateOptions = aloneDateOptions.splice(0, 8);
        if (batchDateOptions.length > 8) batchDateOptions = batchDateOptions.splice(0, 8);

        node.meeting = {
          meetings,
          dateOptions,
          batchDateOptions,
          aloneDateOptions,
          myMeeting,
          hasSubmittedMeeting
        };
      });
  },
  getLoginUrl(lang) {
    return `${process.env.LOGIN_DOMAIN}/api/members/oauth?backurl=${encodeURIComponent(
      window.location.href
    )}&locale=${this.getDomainLocale(lang).replace("-", "_")}`;
  },
  getPersonCenterUrl(lang) {
    return `${process.env.REACT_APP_ACCOUNT_DOMAIN}/user-centre?lang=${
      lang === "zh" ? "zh_CN" : "en_US"
    }&externalLink=true&from=${encodeURIComponent(window.location.href)}`;
  },
  getRegisterUrl(lang) {
    return `${process.env.LOGIN_DOMAIN}/api/members/register?backurl=${encodeURIComponent(
      window.location.href
    )}&locale=${this.getDomainLocale(lang).replace("-", "_")}`;
  },
  getResetPasswordUrl() {
    return process.env.LOGIN_DOMAIN === "https://www.robomaster.com"
      ? $const.RESET_PASSWORD_PRO
      : $const.RESET_PASSWORD_DBETA;
  },
  getRMHomeUrl(lang) {
    return `${process.env.LOGIN_DOMAIN}/${this.getDomainLocale(lang)}`;
  },
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  getUrlQueryLocate() {
    let lang = this.getParameterByName("locale");
    if (lang === "zh" || lang === "zh-CN") {
      lang = "zh";
    } else if (lang === "en" || lang === "en-US") {
      lang = "en";
    } else {
      lang = "";
    }
    return lang;
  },
  /**
   * 获取浏览器语言。
   */
  getBrowserLanguage() {
    const language = navigator.language;
    if (language.includes("zh")) return "zh";
    return "en";
  },
  getFormHistory(id, commonInputs, formInputs, feedBackInputs) {
    // 最终交付的历史记录
    let history = [];
    let formHistory = [];
    commonInputs &&
      commonInputs.nodes &&
      commonInputs.nodes.forEach(item => {
        if (item.formId === id) {
          formHistory.push({
            stringInputs: item.stringInputs.nodes,
            intInputs: item.intInputs.nodes,
            floatInputs: item.floatInputs.nodes,
            datetimeInputs: item.datetimeInputs.nodes,
            num: item.num,
            createdAt: item.createdAt
          });
        }
      });
    // 梳理用户提交的input内容
    let myInputs = [];
    let feedbackInput = [];
    formInputs.forEach(item => {
      // 暂时只有上传组件 以及 普通输入框组件
      if (item.userShow === $const.USER_SHOW.SHOW) {
        myInputs.push(item);
      }
    });
    // 梳理反馈的内容
    feedBackInputs.forEach(item => {
      // Excel 组件不在报名端展示，其余按照 userShow 字段进行判断
      if (
        item.userShow === $const.USER_SHOW.SHOW &&
        item.input.viewType !== $const.INPUTVIEWTYPE.ONLINE_EXCEL
      ) {
        feedbackInput.push(item);
      }
    });
    formHistory.forEach(item => {
      // 单次历史内容
      let historyItem = {
        createdAt: item.createdAt,
        num: item.num,
        www: [],
        cms: []
      };
      // 每次提交的东西 包含表单 以及 反馈
      // 表单的内容
      myInputs.forEach(input => {
        // 循环遍历四个输入存储截止
        item.stringInputs.length > 0 &&
          item.stringInputs.forEach(stringinput => {
            if (stringinput.keyNameUuid === input.keyNameUuid) {
              // 命中
              historyItem.www.push({
                keyNameUuid: input.keyNameUuid,
                value: stringinput.value,
                input: input.input,
                labelUuidI18n: input.labelUuidI18n,
                goptions: input.goptions && input.goptions.nodes
              });
            }
          });
        item.intInputs.length > 0 &&
          item.intInputs.forEach(intInput => {
            if (intInput.keyNameUuid === input.keyNameUuid) {
              // 命中
              historyItem.www.push({
                keyNameUuid: input.keyNameUuid,
                value: intInput.value,
                input: input.input,
                labelUuidI18n: input.labelUuidI18n,
                goptions: input.goptions && input.goptions.nodes
              });
            }
          });
        item.floatInputs.length > 0 &&
          item.floatInputs.forEach(floatInput => {
            if (floatInput.keyNameUuid === input.keyNameUuid) {
              // 命中
              historyItem.www.push({
                keyNameUuid: input.keyNameUuid,
                value: floatInput.value,
                input: input.input,
                labelUuidI18n: input.labelUuidI18n,
                goptions: input.goptions && input.goptions.nodes
              });
            }
          });
        item.datetimeInputs.length > 0 &&
          item.datetimeInputs.forEach(datetimeInput => {
            if (datetimeInput.keyNameUuid === input.keyNameUuid) {
              // 命中
              historyItem.www.push({
                keyNameUuid: input.keyNameUuid,
                value: datetimeInput.value,
                input: input.input,
                labelUuidI18n: input.labelUuidI18n,
                goptions: input.goptions && input.goptions.nodes
              });
            }
          });
      });
      feedbackInput.forEach(input => {
        item.stringInputs.length > 0 &&
          item.stringInputs.forEach(stringinput => {
            if (stringinput.keyNameUuid === input.keyNameUuid) {
              // 命中
              historyItem.cms.push({
                keyNameUuid: input.keyNameUuid,
                value: stringinput.value,
                labelUuidI18n: input.labelUuidI18n,
                input: input.input,
                goptions: input.goptions && input.goptions.nodes
              });
            }
          });
        // 例如分数
        item.floatInputs.length > 0 &&
          item.floatInputs.forEach(floatinput => {
            if (floatinput.keyNameUuid === input.keyNameUuid) {
              // 命中
              historyItem.cms.push({
                keyNameUuid: input.keyNameUuid,
                value: floatinput.value,
                labelUuidI18n: input.labelUuidI18n,
                input: input.input,
                goptions: input.goptions && input.goptions.nodes
              });
            }
          });
      });
      history.push(historyItem);
    });
    return history;
  },
  /**
   * 通过学校tag获取当前队伍的tag
   */
  getTeamTagBySchools(schoolInfo) {
    return schoolInfo[0].tags;
  },
  getTeamFlow(teamInfo) {
    let flow = undefined;
    let tags = [];
    if (
      teamInfo.collegeId &&
      teamInfo.college &&
      teamInfo.college.tags &&
      teamInfo.college.tags.length > 0
    ) {
      tags = teamInfo.college.tags;
    }

    // 如果已经有参赛数据 则去参赛数据里的流程
    if (
      !flow &&
      teamInfo.registrations &&
      teamInfo.registrations.nodes &&
      teamInfo.registrations.nodes[0] &&
      teamInfo.registrations.nodes[0].flowId
    ) {
      let flowId = teamInfo.registrations.nodes[0].flowId;
      teamInfo.gevent.flows.nodes.forEach(item => {
        if (item.id === flowId) {
          flow = item;
        }
      });
    }

    if (!flow && tags.length > 0) {
      // 先根据学校的tag
      tags.forEach(tag => {
        teamInfo.gevent &&
          teamInfo.gevent.flows &&
          teamInfo.gevent.flows.nodes &&
          teamInfo.gevent.flows.nodes.forEach(item => {
            let teamTags = item.tags;
            teamTags &&
              teamTags.nodes &&
              teamTags.nodes.length > 0 &&
              teamTags.nodes.forEach(teamTag => {
                if (teamTag.id === tag.id && !flow) {
                  flow = item;
                }
              });
          });
      });
    }

    if (!flow && teamInfo.gevent && teamInfo.gevent.defaultFlowId) {
      // 在获取比赛的默认flowid
      teamInfo.gevent.flows.nodes.forEach(item => {
        if (item.id === teamInfo.gevent.defaultFlowId) {
          flow = item;
        }
      });
    }

    if (
      !flow &&
      teamInfo.gevent &&
      teamInfo.gevent.flows &&
      teamInfo.gevent.flows.nodes &&
      teamInfo.gevent.flows.nodes[0]
    ) {
      // 最后在默认第一个
      flow = teamInfo.gevent.flows.nodes[0];
    }
    return flow;
  },

  /*
   * 获取当前用户所在的Flow，由于与个人报名详情页的event数据结构不一致，引申出V2版本
   */
  getPersonFlowV2(event, flowId) {
    let flow = undefined;
    if (flowId) {
      // 已经报名
      event.attributes.flows.forEach(item => {
        if (item.id === flowId) {
          flow = item;
        }
      });
    }
    if (!flow && event && event.defaultFlowId) {
      // 在获取比赛的默认flowid
      event.attributes.flows.forEach(item => {
        if (item.id === event.attributes.defaultFlowId) {
          flow = item;
        }
      });
    }
    if (!flow && event && event.attributes && event.attributes.flows && event.attributes.flows[0]) {
      // 最后在默认第一个
      flow = event.attributes.flows[0];
    }
    return flow;
  },

  getPersonFlow(event, flowId) {
    let flow = undefined;
    if (flowId) {
      // 已经报名
      event.flows.nodes.forEach(item => {
        if (item.id === flowId) {
          flow = item;
        }
      });
    }
    if (!flow && event && event.defaultFlowId) {
      // 在获取比赛的默认flowid
      event.flows.nodes.forEach(item => {
        if (item.id === event.defaultFlowId) {
          flow = item;
        }
      });
    }
    if (!flow && event && event.flows && event.flows.nodes && event.flows.nodes[0]) {
      // 最后在默认第一个
      flow = event.flows.nodes[0];
    }
    return flow;
  },
  isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  },
  checkIsComplete(nodes, gameData) {
    let isComplete = false;
    let node;
    let inputKey;
    // 找到参赛反馈环节
    nodes.forEach(item => {
      if (item.stageType === $const.STAGE_TYPE.FEEDBACK) {
        node = item;
      }
    });
    if (node) {
      // 找到参赛反馈环节里的反馈key
      node.forms &&
        node.forms.nodes &&
        node.forms.nodes[0] &&
        node.forms.nodes[0].formInputs &&
        node.forms.nodes[0].formInputs.nodes &&
        node.forms.nodes[0].formInputs.nodes.forEach(item => {
          if (
            item.inputSource === $const.INPUTSOURCE.WWW &&
            item.input &&
            item.input.viewType === $const.INPUTVIEWTYPE.RADIO_FEEDBACK
          ) {
            inputKey = item.keyNameUuid;
          }
        });
    }
    if (
      inputKey &&
      gameData &&
      gameData.commonInputs &&
      gameData.commonInputs.nodes &&
      gameData.commonInputs.nodes.length > 1
    ) {
      gameData.commonInputs.nodes.forEach(input => {
        input.stringInputs &&
          input.stringInputs.nodes &&
          input.stringInputs.nodes.forEach(string => {
            // 找到参赛反馈的结果
            if (string.keyNameUuid === inputKey && string.value === $const.FEEDBACK_VALUE) {
              isComplete = true;
            }
          });
      });
    }
    return isComplete;
  },
  formatPhone(phone) {
    let consigneePhone = ["", ""];
    if (phone && phone.split(" ").length > 1) {
      consigneePhone[0] = phone.split(" ")[0];
      consigneePhone[1] = phone.split(" ")[1];
    }
    return consigneePhone;
  },
  isEmptyRichText(txt) {
    if (!txt) {
      return true;
    }
    return (
      txt.replace(/<([a-z]+?[0-9]*?)(?:\s+?[^>]*?)?>(\s|<br>|<br\/>)*?<\/(?!img)\1>/gi, "") === ""
    );
  },
  extractHostname(url) {
    let hostname = "";
    // find & remove protocol (http, ftp, etc.) and get hostname
    if (url.indexOf("//") > -1) {
      hostname = url.split("/")[2];
    } else {
      hostname = url.split("/")[0];
    }
    // find & remove port number
    hostname = hostname.split(":")[0];
    // find & remove "?"
    hostname = hostname.split("?")[0];
    return hostname;
  },
  extractFileName(url) {
    if (!url) return "";
    let splitStr = url.split("/");
    if (splitStr.length <= 1) return url;
    return splitStr[splitStr.length - 1];
  },
  extractFileSuffix(fileName) {
    if (!fileName) return "";
    let splitStr = fileName.split(".");
    if (splitStr.length <= 1) return "";
    return splitStr[splitStr.length - 1];
  },
  getSafePicUrl(url) {
    if (!url) return "";
    const tmpUrl = url.toLowerCase();
    const validDomains = [
      "rm-static.djicdn.com",
      "rm-staging.djicdn.com",
      "stg-robomasters-hz-q0o2.oss-cn-hangzhou.aliyuncs.com",
      "pro-robomasters-hz-n5i3.oss-cn-hangzhou.aliyuncs.com",
      "terra-cn-oss-cdn-public-uat.oss-cn-hangzhou.aliyuncs.com",
      "stag-terra-1-g.djicdn.com",
      "terra-us-uat-rm-stg-pub-us.s3.amazonaws.com",
      "terra-1-g.djicdn.com",
      "terra-us-pro-rm-prod-pub-us.s3.amazonaws.com",
      "terra-cn-oss-cdn-public-uat.oss-cn-hangzhou.aliyuncs.com",
      "terra-cn-oss-cdn-public-pro.oss-cn-hangzhou.aliyuncs.com"
    ];
    const invalidFileSuffix = ["js", "php"];
    const domain = this.extractHostname(tmpUrl);
    if (!domain || !validDomains.includes(domain)) return "";
    const fileName = this.extractFileName(tmpUrl);
    const suffix = this.extractFileSuffix(fileName);
    if (suffix && invalidFileSuffix.includes(suffix)) return "";
    return url;
  },
  async downloadFile(url, fileName, headers, callback) {
    let fileData = await this.getFileBlob(url, headers);
    saveAs(fileData, fileName);
    callback && callback();
  },
  getFileBlob(url, headers) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        resolve(xhr.response);
      };
      xhr.open("GET", url);
      for (let item in headers) {
        if (headers.hasOwnProperty(item)) {
          xhr.setRequestHeader(item, headers[item]);
        }
      }
      xhr.responseType = "blob";
      xhr.send();
    });
  },
  /*
   * 与后端映射的语言表
   */
  beLangMap(lang) {
    const map = {
      en: "en",
      zh: "zh-CN"
    };
    return map[lang];
  },
  formatDate(fmt = "yyyy-MM-dd", date) {
    const realDate = date ? new Date(date) : new Date();
    const o = {
      "M+": realDate.getMonth() + 1,
      "d+": realDate.getDate(),
      "h+": realDate.getHours(),
      "m+": realDate.getMinutes(),
      "s+": realDate.getSeconds(),
      "q+": Math.floor((realDate.getMonth() + 3) / 3),
      S: realDate.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) {
      const y = (realDate.getFullYear() + "").substr(4 - RegExp.$1.length);
      fmt = fmt.replace(RegExp.$1, y);
    }
    for (const k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        const d = RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length);
        fmt = fmt.replace(RegExp.$1, "" + d);
      }
    }
    return fmt;
  },
  getImgSize(file) {
    return new Promise((res, rej) => {
      try {
        const reader = new FileReader();
        reader.onload = function() {
          let img = new Image();
          img.src = this.result;
          // 定时检查
          let set = setInterval(() => {
            if (img.width > 0 && img.height) {
              clearInterval(set);
              res(img);
            }
          }, 10);

          // 检查缓存
          if (img.complete) {
            clearInterval(set);
            res(img);
          }
          // 检查onload
          else {
            img.onload = function() {
              clearInterval(set);
              res(img);
            };
          }
        };
        reader.readAsDataURL(file);
      } catch (error) {
        rej(error);
      }
    });
  },
  /**
   * 重复调用此接口，用于登录保活。
   */
  keepLoginAliveFn() {
    agent.Games.getV2Categories("zh-CN");
  },
  keepLoginAlive() {
    if (timer) return;
    timer = setInterval(() => {
      this.keepLoginAliveFn();
    }, 1000 * 60);
  },
  breakLoginOff: () => {
    if (timer) {
      clearInterval(timer);
    }
  },
  log: data => {
    try {
      if (!data) return "";
      return JSON.stringify(data);
    } catch (error) {
      return "";
    }
  },
  // 通过school name查询对应的id
  getSchoolIdByName: async name => {
    const res = await agent.SassPlatform.searchSchools({ name, mode: "1" });
    if (res && res.success && Array.isArray(res.data) && res.data.length > 0) {
      const schoolInfo = res.data[0];
      const { id } = schoolInfo;
      return id;
    }
    return "";
  },
  /**
   * 校验个人信息是否符合赛事要求
   * @param {*} userId 用户ID
   * @param {*} eventId 赛事ID
   * @param {*} teamId 队伍ID
   * @param {*} school 学校名
   * @param {*} scene 校验场景 '1': 加入战队，'2': 创建战队，'3': 修改战队资料，'4': 提交战队资料
   * @param {*} code 加入战队场景下，此参数为必须，为所加入职位code
   */
  verifyPersonalInfo: async (userId, eventId, teamId = "", scene, school = [], code = "") => {
    let schools = [];
    // 如果有学校，则需要通过学校name查询对应id，将id传给后端进行校验
    if (school && school.length > 0) {
      for (let i = 0; i < school.length; i++) {
        const res = await agent.SassPlatform.searchSchools({ name: school[i], mode: "1" });
        if (res && res.success && Array.isArray(res.data) && res.data.length > 0) {
          const schoolInfo = res.data[0];
          const { id } = schoolInfo;
          schools.push(id || "");
        }
      }
    }
    try {
      const res = await agent.SassPlatform.verifyPersonalInfo({
        userId: String(userId),
        eventId: String(eventId),
        teamId: String(teamId),
        school: schools,
        scene: String(scene),
        code: String(code)
      });
      return res;
    } catch (error) {
      console.log(error);
    }
  },
  openPersonalCenter(lang) {
    if (window.open) {
      const url = `${process.env.REACT_APP_ACCOUNT_DOMAIN}/user-centre?lang=${
        lang === "zh" ? "zh_CN" : "en_US"
      }`;
      window.open(url, "__blank");
    }
  },
  /**
   * 防抖函数
   * @param {*} fn
   * @param {*} time
   * @returns
   */
  debounce: (fn, time = 500) => {
    let timer;
    const _this = this;
    return function(...args) {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        fn.apply(_this, args);
        timer = null;
      }, time);
    };
  },
  /**
   * GA4埋点，获取部分pageName
   */
  getPageName: () => (window.location.pathname ? window.location.pathname.replace("/", "") : ""),
  // 判断两个时间是否在同一天
  isSameDay: (timeA, timeB) => {
    const date1 = new Date(timeA);
    const date2 = new Date(timeB);

    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  },
  /**
   * 从pca数据中获取国家和省份及其城市列表。
   * @param {*} pcaData 来自agent.Common.getPca
   * @returns 格式化以后的数据
   */
  getLevelCity: pcaData => {
    // 四个直辖市
    const citysOf4 = ["11", "12", "31", "50"];
    // 香港，澳门，台湾
    const citysOf3 = ["810000", "820000", "710000"];
    const data = [];
    for (let item of pcaData) {
      const { value, label, children } = item;
      if (citysOf3.includes(value) || citysOf4.includes(value)) {
        data.push({ value, label });
      } else {
        const formatChildren = children.map(childItem => {
          return {
            value: childItem.value,
            label: childItem.label
          };
        });
        data.push({ ...item, children: formatChildren });
      }
    }
    return data;
  },
  /**
   * 返回当前字符串所占字符数
   * 汉字占两个字符，英文字母扎一个字符。
   * */
  checkCharNum: str => {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 255) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  },
  getCdnUrl: url => {
    return url
      .replace("pro-robomasters-hz-n5i3.oss-cn-hangzhou.aliyuncs.com", "cdn-hz.robomaster.com")
      .replace(
        "stg-robomasters-hz-q0o2.oss-cn-hangzhou.aliyuncs.com",
        "cdn-hz-staging.robomaster.com"
      );
  },
  openTeamSubmitEntryListPage: ({ teamId, lang, bbsTeamId, eventId, collectionId }) => {
    const map = {
      en: "en_US",
      zh: "zh_CN"
    };
    window.location.replace(
      `/team-sumit-entry-list?teamId=${teamId}&lang=${map[lang]}&bbsTeamId=${bbsTeamId}&eventId=${eventId}&collectionId=${collectionId}`
    );
  }
};



// WEBPACK FOOTER //
// ./src/helper/util.js